import './styles/home.scss'
import Paul from './images/Paul_hero.webp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Testimonials from './Testimonials';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import moment from 'moment';
import bio from './images/bio_photo.webp';

export default function Home() {
  const navigate = useNavigate()
  const startDate = '2025/01/06 09:00:00';
  const today = moment();
  const [showCount, setShowCount] = useState(true)
  const [countDown, setCountDown] = useState({})
  const [showBreak, setShowBreak] = useState(true)

  useEffect(() => {
    if (today.diff(moment(startDate), 'seconds') > 0) {
      setShowCount(false)
    }
    setTimeout(() => {
      calculateTimeLeft()
    }, 1000)
  }, [showCount, today])

  useEffect(() => {
    if (window.innerWidth < 800) {
      setShowBreak(false)
    }
  })



  const calculateTimeLeft = () => {
    let event = new Date(startDate).getTime();
    let now = new Date().getTime();

    let distance = event - now;

    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    setCountDown({ days: days, hours: hours, mins: minutes, secs: seconds })
  };



  return (
    <main className="home__main">
      {showCount ? (
        <section className="count__down">
          <p>The 30 Day Challenge Starts In:</p>
          <p className='count nums'><span>0{countDown.days}</span> <span>{countDown.hours}</span>
            <span>{countDown.mins}</span> <span>{countDown.secs}</span></p>
          <p className='count'><span>DAYS</span> <span>HOURS</span> <span>MINS</span> <span>SECS</span></p>
        </section>
      ) : null}
      <section className="hero">
        <h1>Take Your First Step<br />Toward Property Success<br />In Just <span>30 Days!</span></h1>
        <article className='hero__row'>
          <section className='hero__row__column'>
            <p>Go From Zero Knowledge to Confidently Starting Your
              Property Journey in Just 30 Days!</p>
            <p>Don't Miss Out! The <strong>FREE 30-Day Property Challenge</strong> Starts
              January 6th—Requires Less Than 2 Hours Per Week.</p>
            <button className='cta--btn' onClick={() => navigate('/registration')} disabled>Too Late! The Challenge Has Started!</button>
          </section>
          <img src={Paul} alt="Paul McFadden" />
        </article>
      </section>
      <section className='bullet__section'>
        <h2>Here's What You'll Get:</h2>
        <p>Led by Paul McFadden, this 30-day challenge is hosted in a private Whatsapp group where you’ll
          get daily guidance, answers to your questions, and support every step of the way.</p>
        <article className='bullet__row'>
          <CheckCircleIcon className='bullet--icon' />
          <p><span>Private Whatsapp Group:</span> Chat and learn in a private Whatsapp group with others on the
            same journey.</p>
        </article>
        <article className='bullet__row'>
          <CheckCircleIcon className='bullet--icon' />
          <p><span>Support from Paul McFadden:</span> Get direct guidance and support from Paul.</p>
        </article>
        <article className='bullet__row'>
          <CheckCircleIcon className='bullet--icon' />
          <p><span>Weekly Zoom Calls:</span> Join weekly Zoom calls with Paul to track progress, ask questions,
            and stay motivated.</p>
        </article>
        <article className='bullet__row'>
          <CheckCircleIcon className='bullet--icon' />
          <p><span>Online Training:</span> Access easy-to-follow lessons and practical tasks to build your
            confidence.</p>
        </article>
        <article className='bullet__row'>
          <CheckCircleIcon className='bullet--icon' />
          <p><span>Bonus:</span> Get a free copy of the <strong>#1 best-seller <em>Your Property Jumpstart</em></strong>, along with the Deal
            Calculator and essential tools to help you succeed!</p>
        </article>
        <p className="end">By the end of the challenge, you’ll have everything you need to confidently take your first steps in
          property investment!</p>
        <button className='cta--btn' onClick={() => navigate('/registration')} disabled>Too Late! The Challenge Has Started!</button>
      </section>
      <section className='why__sect'>
        <h2>Why Do Most Beginners Struggle</h2>
        <p>Getting started in property investment isn’t easy. The overwhelming amount of advice online often
          leads to confusion. Where do you begin? What strategies actually work?<br /> How do you find the
          money to fund deals?</p>
        <p>You’ve probably Googled, watched videos, and downloaded free guides, {!showBreak ? <br /> : null} but none of it seems to
          stick or give you the confidence to take action.</p>
        <p>The truth is, most beginners struggle because they lack a proven, actionable plan <br />and expert
          guidance to help them succeed.</p>
        <h2>Think Property Investment Isn’t for You? <span>Think Again</span></h2>
        <p>Think property investment isn’t for you? Maybe you’re worried you don’t have the time, {!showBreak ? <br /> : null}money, or
          experience to get started.</p>
        <p>But here’s the truth: You don’t need to be rich, have years of experience, or spend hours every day
          to succeed in property investment. This <strong>30-Day Challenge</strong> was specifically designed for people just
          like you—those who want to learn the basics, take action, and see real results without feeling
          overwhelmed.</p>
        <p>By breaking down everything into simple, manageable steps, this challenge makes property
          investment accessible for anyone, no matter where you’re starting from.</p>
        <p>So, if you’ve ever thought property investment wasn’t for you, think again. With the right plan,
          guidance, and support, you can confidently take your first step toward building a better financial
          future.</p>
      </section>
      <section className='bullet__section'>
        <h2>Here’s How The 30 Day Challenge
          Will Help You Get Started In Property Investment:</h2>
        <section className="bullet__cols">
          {/* COLUMN ONE */}
          <article className='cols'>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Learn the Basics:</span> Discover simple strategies to start investing, even with little or no money.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Spot Great Deals:</span> Find profitable property opportunities in your area.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Understand Financing:</span> Explore creative ways to fund your deals and make them happen.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Avoid Costly Mistakes:</span> Learn how to manage risks and make smart, well-planned decisions.</p>
            </article>
          </article>
          {/* COLUM TWO */}
          <article className='cols'>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Gain Confidence:</span> Take your first steps with guidance and support from experienced investors.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Build Long-Term Income:</span> Create steady cash flow and financial freedom.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Take Action:</span> Learn how to move forward with clarity and confidence.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Plan for the Future:</span> Create a 12-month action plan to grow your property portfolio with
                confidence.</p>
            </article>
          </article>
        </section>
        <button className='cta--btn' onClick={() => navigate('/registration')} disabled>Too Late! The Challenge Has Started!</button>
      </section>
      <section className='why__sect'>
        <h2>Don’t Just Take My Word For It. <br />Here’s What Our Past Participants Say:</h2>
        <Testimonials />
      </section>
      <section className="bio">
        <section className="bio__cols">
          <article className='text__col'>
            <h2>A Special Message From Paul</h2>
            <p>Hi, I’m Paul McFadden, and just like you, I started with no experience, limited resources, and big dreams of financial freedom.</p>
            <p>Fast forward to today, and I’ve built a property portfolio valued at over £22 million and helped over 1,000 students achieve their first property deals and passive income goals.</p>
            <p>I know how overwhelming it can feel to start in property investment, not knowing where to begin or how to make it work for you. That’s why I created the 30 Day Property Challenge: to break everything into simple steps, remove confusion, and help you get started on your property journey.</p>
          </article>
          <article className='img__col'>
            <img src={bio} alt="Paul with his Lamborghinni" />
          </article>
        </section>
        <h6>You’re One Step Away from Starting Your Property Journey</h6>
        <button className='cta--btn' onClick={() => navigate('/registration')} disabled>Too Late! The Challenge Has Started!</button>
      </section>
    </main>
  )
}